import React, { useState, useContext, useEffect } from "react";
import LoginContext from "./context/LoginContext";
import { toast,ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import UIkit from "uikit";
import Icons from "uikit/dist/js/uikit-icons";
import 'uikit/dist/css/uikit.min.css';

import Cookies from "js-cookie"; // Install js-cookie: npm install js-cookie
import { useParams, useLocation,useNavigate } from "react-router-dom";
UIkit.use(Icons);



function Login() {
  const { formList, setSelectedCategoryId, itemList,callWaiter,tbid, setTbid,
    via,setVia,hotelID,setSlug ,responseData,filteredData,setFilteredData} =
    useContext(LoginContext);

  const [quantity, setQuantity] = useState(1);
 
  const [selectedItem, setSelectedItem] = useState(null); // State for selected item
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [cartItems, setCartItems] = useState([]); // Cart items state
  const [cartModalOpen, setCartModalOpen] = useState(false); // State for cart popup
  
  const [queryParams, setQueryParams] = useState({ tbid: null, via: null, type: null });


  const { hotelName } = useParams(); // Get hotel name from the URL
  const location = useLocation(); // Get query parameters
  const [query, setQuery] = useState('');
  



  const navigate = useNavigate();

  const handleViewOrder = () => {
    setCartModalOpen(true); // Open cart popup
  };


  
  useEffect(() => {
    // Extract slug from the URL path
    const currentPath = window.location.pathname;
  const normalizedPath = currentPath.replace(/\/$/, ""); // Remove trailing slash
  const extractedSlug = normalizedPath.split("/").pop();

    if (!extractedSlug) {
      console.error("Error: Slug not found in URL.");
      navigate("/404");
      return;
    }

    // Extract query parameters from the URL
    const searchParams = new URLSearchParams(window.location.search);
    const tbid = searchParams.get("tbid");
    const via = searchParams.get("via");
    const type = searchParams.get("type");

    if (type !== "R" && type !== "T") {
      console.error("Error: Invalid 'type' parameter. Must be 'R' or 'T'.");
      navigate("/404");
      return;
    }
    
    if (!tbid || !via) {
      console.error("Error: tbid or via not found in query params.");
      navigate("/404");
      return;
    }

    // Save slug and query parameters to state
    setSlug(extractedSlug);
    setQueryParams({ tbid, via, type });
   

   
  }, [navigate]);


  

  const handleSearch = (event) => {
    event.preventDefault();
    const lowercasedQuery = query.toLowerCase();
  
    // Filter items based on search query
    const filteredItems = itemList.filter(item => {
      // Ensure that item.Name exists before calling toLowerCase
      const itemName = item.Name ? item.Name.toLowerCase() : '';
      return itemName.includes(lowercasedQuery);
    });
  
    // Update state with filtered data
    setFilteredData(filteredItems); // Set the filtered items to the state
  };
  



  useEffect(() => {
    // Load cart items from cookies when component mounts
    const storedCart = Cookies.get("cartItems");
    if (storedCart) {
      setCartItems(JSON.parse(storedCart));
    }
  }, []);

   // Parse query parameters when location or hotelName changes
   useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    setTbid(searchParams.get("tbid"));
    setVia(searchParams.get("via"));


    console.log("Hotel Name:", hotelName);
    console.log("Table ID:", tbid);
    console.log("Via:", via);
  }, [location.search, hotelName]);

  const handleAddToCart = (item) => {
    setSelectedItem(item); // Set the selected item
    setQuantity(1); // Reset quantity
    setIsModalOpen(true); // Open modal 
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close modal
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedItem(null);
  };
  const closeCartModal = () => {
    setCartModalOpen(false); // Close cart popup
  };

  const handleQuantityChange = (change) => {
    setQuantity((prevQuantity) => {
      const newQuantity = prevQuantity + change;
      console.log("Button clicked, new quantity:", newQuantity);
      return newQuantity;
    });
  };
  

  const handleAddNow = () => {
    if (selectedItem) {
      // Retrieve existing cart items from the cookie or initialize an empty array
      const existingCart = Cookies.get("cartItems")
        ? JSON.parse(Cookies.get("cartItems"))
        : [];
  
      // Create a new cart item with the selected item and quantity
      const newCartItem = { ...selectedItem, quantity };
  
      // Add the new cart item to the existing cart
      const updatedCart = [...existingCart, newCartItem];
  
      // Save the updated cart back to the cookie
      Cookies.set("cartItems", JSON.stringify(updatedCart), { expires: 7 });
  
      // Update the cartItems state to reflect the changes
      setCartItems(updatedCart);
  
      console.log("Updated cart:", updatedCart);
      setIsModalOpen(false); // Close the modal
  
      // Show success toast
      toast.success("Item added to cart successfully!", {
        position: "top-center",
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
      });
    }
  };
  
  

  const handleAddOrder = async () => {
    // Prepare the payload for the API request
    const { tbid, via } = queryParams; // Access tbid and via from queryParams

    if (!tbid || !via) {
      console.error("TableID or Via is missing!");
      return;
    }
    const payload = {
      HotelID: hotelID,
      Flag: "ORDER",
      TableID: tbid, // Use dynamic TableID if available
      Via: via,
      IsNotify: "Y",
      Values: cartItems.map((item) => ({
        ItemID: item.ItemID, // Ensure cartItems contains ItemID
        Qty: item.quantity,
        Rate: item.Rate,
        DisPer: item.DisPer || 0, // Assuming a default discount percentage of 0
      })),
    };
  
    console.log("Payload to send:", payload);
  
    try {
      const response = await fetch("https://testing.esnep.com/ehotel/api/waiter/menu-qr", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
  
      if (response.ok) {
        const data = await response.json();
        console.log("Order placed successfully:", data);
  
        // Show success toast
        toast.success("Order placed successfully!", {
          position: "top-center",
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
        });
  
        // Clear cart items from state and cookies
        setCartItems([]); // Clear state
        Cookies.remove("cartItems"); // Remove from cookies
  
        // Close cart popup
        closeCartModal();
      } else {
        console.error("Error placing order:", response.statusText);
        toast.error("Failed to place order. Please try again.", {
          position: "top-center",
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
        });
      }
    } catch (error) {
      console.error("Error placing order:", error);
      toast.error("An error occurred while placing the order.", {
        position: "top-center",
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
      });
    }
  };  

// UseEffect to update filteredData when the search query changes
useEffect(() => {
  if (query === "") {
    setFilteredData(itemList); // When query is empty, show all items
  } else {
    const lowercasedQuery = query.toLowerCase();
    const filteredItems = itemList.filter(item => {
      return item.Name.toLowerCase().includes(lowercasedQuery);
    });
    setFilteredData(filteredItems); // Update filteredData based on search
  }
}, [query, itemList]); // Trigger the effect when query or itemList changes
  return (
    <>
    <ToastContainer />
    <div className="menu-header">
  {responseData && responseData.length > 0 && (
    <>
      <img 
        src={responseData[0].Logo} 
        alt={`${responseData[0].ComName} Logo`} 
        className="menu-logo" 
      />
      <div className="menu-details">
        <h1 className="menu-name">{responseData[0].ComName}</h1>
        <p className="menu-address">Kalimati, Kathmandu</p>
      </div>
    </>
  )}

  {/* Icon Button outside of responseData */}
  <button className="icon-btn" onClick={callWaiter}>
    <i className="uk-icon" uk-icon="icon: bell"></i>  {/* Example Icon */}
  </button>
</div>

<div className="uk-container uk-margin-small-top">
        <form onSubmit={handleSearch} className="search-form">
          <div className="uk-flex uk-flex-between uk-flex-middle">
            <input
              className="uk-input uk-width-1-1 uk-border-rounded search-input"
              type="search"
              placeholder="Search for items..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
            <button className="uk-button uk-button-primary uk-border-rounded search-btn" type="submit">
              <span uk-icon="icon: search; ratio: 1.5"></span>
            </button>
          </div>
        </form>
      </div>


      <section id="secondpart">
        <div className="uk-container uk-margin-small-top">
          <div className="uk-grid uk-grid-medium" uk-grid>
            <div className="uk-visible@s uk-width-1-3@s uk-width-1-5@m">
              <h3>
                <span className="uk-margin-small-right" uk-icon="list"></span>
                Categories
              </h3>
              <div className="forborder"></div>
              <ul className="uk-list">
                {formList && formList.length > 0 ? (
                  formList.map((item, index) => (
                    <li
                      key={index}
                      onClick={() => setSelectedCategoryId(item.CategoryID)}
                    >
                      {item.Name}
                    </li>
                  ))
                ) : (
                  <li>No categories available</li>
                )}
              </ul>
            </div>

            <div className="uk-width-expand@s">
            <div
                className="uk-hidden@s"
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: '5px',
                }}
              >
              <h3>
                <span className="uk-margin-small-right" uk-icon="bolt"></span>
                Items
              </h3>
              <button
                  className="uk-button uk-button-default"
                  uk-toggle="target: #offcanvas-categories"
                >
                  <span uk-icon="list"></span>
                </button>
                </div>
              <div className="uk-grid uk-child-width-1-1@s uk-grid-match uk-grid-small" uk-grid>
              {filteredData.length > 0 || itemList.length > 0 ? (
    (filteredData.length > 0 ? filteredData : itemList).map((item, index) => (
                    <div key={index}>
                      <div className="uk-card uk-card-default uk-flex uk-margin">
                        <img src={item.Image} alt="Item" />
                        <div className="uk-card-body">
                          <h5 className="uk-card-title" style={{ margin: 0 }}>
                            {item.Name}
                          </h5>
                          <p>{item.Description}</p>
                          <p style={{ margin: "5px 0", color: "#E63946" }}>
                            {item.Rate}
                          </p>
                          <div className="uk-text-right">
                            <button
                              className="uk-button uk-button-default"
                              onClick={() => handleAddToCart(item)}
                            >
                              <span
                                uk-icon="cart"
                                className="uk-margin-small-right"
                              ></span>
                              Add to Cart
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                   ))
                  ) : (
                    <div>No items available</div> // Display message when no items are available
                  )}
              </div>
            </div>
          </div>
        </div>

        {/* Centered Modal */}
        
        {isModalOpen && (
  <div className="react-modal-overlay">
    <div className="react-modal-dialog">
      <button className="react-modal-close" onClick={closeModal}><span uk-icon="close"></span></button>
      <div className="react-modal-header">
        <h2 className="react-modal-title">
          {selectedItem ? selectedItem.Name : "Item Name"}
        </h2>
      </div>
      {selectedItem && (
        <div className="react-modal-body">
         <div className="modal-content">

    <img src={selectedItem.Image} alt="Item" />

  <div className="modal-details">
    <span className="modal-name">{selectedItem.Name || 'Item Name'}</span>
    <span className="modal-rate">{selectedItem.Rate || '0.00'}</span>
  </div>
</div>

          <div className="quantity-selector">
  <label htmlFor="quantity" className="quantity-label">
    Quantity:
  </label>
  <button
    className="quantity-button decrement"
    onClick={() => handleQuantityChange(-1)}
    disabled={quantity === 1}
  >
    -
  </button>
  <input
    id="quantity"
    type="text"
    value={quantity}
    readOnly
    className="quantity-input"
  />
  <button
    className="quantity-button increment"
    onClick={() => handleQuantityChange(1)}
  >
    +
  </button>
</div>


          <p><strong>Subtotal:</strong> {quantity * selectedItem.Rate}</p>

          <div className="modal-footer">
            <button onClick={handleAddNow}>Add Now</button>
          </div>
          
        </div>
      )}
    </div>
  </div>
)}


 {/* View Order Button */}
 {cartItems.length > 0 && (
          <button
            className="view-order-btn"
            onClick={handleViewOrder}
            style={{
              position: "fixed",
              bottom: "0px",
              padding: "10px 20px",
              backgroundColor: "#007bff",
              color: "#fff",
              border: "none",
              cursor: "pointer",
              width:"100%"
            }}
          >
            View Order
          </button>
        )}


         {/* Cart Items Popup */}
         {cartModalOpen && (
          <div className="react-modal-overlay">
            <div className="react-modal-dialog">
              <button className="react-modal-close" onClick={closeCartModal}>
                <span uk-icon="close"></span>
              </button>
              <h3>Your Cart</h3>
              <table className="cart-table">
  <thead>
    <tr>
      <th>S.N</th>
      <th>Name</th>
      <th>Quantity</th>
      <th>Rate</th>
      <th>Subtotal</th>
    </tr>
  </thead>
  <tbody>
    {cartItems.map((item, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{item.Name}</td>
        <td>{item.quantity}</td>
        <td>{item.Rate}</td>
        <td>{item.quantity * item.Rate}</td>
      </tr>
    ))}
  </tbody>
</table>
<div className="uk-text-right">
<button className="orderbutton" onClick={handleAddOrder}>Add Order</button>
</div>
            </div>
          </div>
        )}


            {/* Off-Canvas for Mobile */}
            <div id="offcanvas-categories" uk-offcanvas="overlay: true">
          <div className="uk-offcanvas-bar">
            <button
              className="uk-offcanvas-close"
             
              uk-close
            ><span uk-icon="icon: close"></span></button>
           
           <ul className="uk-list">
                {formList && formList.length > 0 ? (
                  formList.map((item, index) => (
                    <li
                      key={index}
                      onClick={() => setSelectedCategoryId(item.CategoryID)}
                    >
                      {item.Name}
                    </li>
                  ))
                ) : (
                  <li>No categories available</li>
                )}
              </ul>
          </div>
        </div>
      </section>

      
    </>
  );
}

export default Login;
